import React from "react";
import { Hidden } from "@material-ui/core";

const MobileHidden = (props) => {
  return <Hidden only={["xs", "sm"]}>{props.children}</Hidden>;
};
export default MobileHidden;
